<template>
  <div class="realizations-swiper">
    <div
      v-swiper-gallery
      class="swiper-container swiper-container--images">
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          v-for="(realization, index) of realizations"
          :key="index"
          class="swiper-slide"
          @click="$_zoom(realization)">
          <picture> 
            <source
              v-for="(image, index) of $_srcSetImages(realization.fields.image.fields.file.url)"
              :key="index"
              :media="`(max-width: ${index}px)`"
              :srcset="image">
            <img
              :src="`${realization.fields.image.fields.file.url}?w=720&fit=scale`"
              :alt="realization.fields.image.fields.description" />
          </picture>
          <!--
          <img :src="realization.fields.image.fields.file.url" />
          -->
          <p v-if="realization.fields.image.fields.didascalia">
            {{ realization.fields.image.fields.didascalia }}
          </p>
        </div>
        <!-- Fine Slides -->
      </div>
    </div>
    <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
  </div>
</template>

<script>

import swiper from './swiper'
export default {
  name: 'ProductGallerySwiper',
  mixins: [swiper],
  props: {
    realizations: {
      type: Array,
      required: true
    }
  },
  methods: {
    $_zoom (realization) {
      this.$emit('zoom', realization)
    },
    $_srcSetImages (image) {
      const images = {
        640: `${image}?w=640&fit=scale`,
        1024: `${image}?w=400&fit=scale`,
        1440: `${image}?w=500&fit=scale`,
        1920: `${image}?w=720&fit=scale`,
      }
      return images
    },
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
